import { _axios } from "../../../Utils/Axios/axios";

export const makeQuiz_Service = async (
  userToken: string,
  lesson_id: string | number,
  how_many: string | number,
  subject_id?: string | number
) => {
  return _axios.post(
    "/make_quiz",
    {
      lesson_id,
      subject_id,
      how_many,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
